import { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectPrefabHeading } from '../../_redux-scene';
import { DesignWindow } from '../desktop/DesignWindow';
import { NonPinnedVariablesWindow } from '../mobile/NonPinnedVariablesWindow';
import { PinnedVariablesWindow } from '../mobile/PinnedVariablesWindow';
import { SingleNonPinnedVariableStepWindow } from '../mobile/SingleNonPinnedVariableStepWindow';
import { OverviewWindow } from './OverviewWindow';
import { PrefabsWindow } from './PrefabsWindow';

export type GiftWindowSteps =
    | 'design'
    | 'prefabs'
    | 'pinned-variables'
    | 'single-non-pinned-variable'
    | 'non-pinned-variables'
    | 'overview';

export type GiftWindowStepProps = {
    onClose: () => void;
    previous: (() => void) | undefined;
    previousButtonText: string | undefined;
    next: (() => void) | undefined;
    nextButtonText: string | undefined;
};

export type ContentFirstGiftWindowStepProps = {
    onClose: () => void;
};

const mapComponentToStep: Record<GiftWindowSteps, (props: GiftWindowStepProps) => ReactElement | null> = {
    'pinned-variables': PinnedVariablesWindow,
    'prefabs': PrefabsWindow,
    'design': DesignWindow,
    'single-non-pinned-variable': SingleNonPinnedVariableStepWindow,
    'non-pinned-variables': NonPinnedVariablesWindow,
    'overview': OverviewWindow
};

export const selectComponentForStep = (step: GiftWindowSteps) => {
    return mapComponentToStep[step];
};

export const useSteps = (steps: GiftWindowSteps[], initialStep: number = 0) => {

    const [step, setStep] = useState(initialStep);
    const next = step < steps.length - 1
        ? () => setStep(step + 1)
        : undefined;
    const previous = step !== 0
        ? () => setStep(step - 1)
        : undefined;

    return { step, next, previous };
};

export const useButtonText = (
    step: GiftWindowSteps, direction: 'next' | 'previous', format: 'long' | 'short'
): string => {

    const { t } = useTranslation();

    const prefabHeading = useSelector(selectPrefabHeading);
    const prefabButtonText = {
        'layouts': 'windows.prefabs.button_text.layouts',
        'designs': 'windows.prefabs.button_text.designs'
    }[prefabHeading];

    const key = {
        'design': prefabButtonText,
        'prefabs': prefabButtonText,
        'single-non-pinned-variable': 'windows.non_pinned_variables.button_text',
        'non-pinned-variables': 'windows.non_pinned_variables.button_text',
        'overview': 'windows.overview.button_text',
        'pinned-variables': 'windows.pinned_variables.button_text'
    }[step];

    return t(`${key}.${direction}.${format}`);
};